/* Gloorlicht — réveil de bienvenue.
   Une seule fois par visiteur : le réveil sonne, s'allume comme un lever de soleil et offre -10 € (code GLOORLICHT10)
   pendant 20 minutes, décomptées sur l'écran du réveil. À l'échéance, le code est retiré du panier s'il y était.
   Aperçu forcé : ajouter ?aube-reveil=1 à l'adresse. */
(() => {
  const CODE = 'GLOORLICHT10';
  const MS = 20 * 60 * 1000;
  const K = 'aube-wake';
  const get = () => { try { return JSON.parse(localStorage.getItem(K) || 'null'); } catch (e) { return null; } };
  const set = (v) => { try { localStorage.setItem(K, JSON.stringify(v)); } catch (e) {} };
  const force = /[?&]aube-reveil=1/.test(location.search);
  if (!force && (window.Shopify?.designMode || /^\/(cart|checkouts?|account)/.test(location.pathname))) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let st = force ? null : get();
  if (st && st.end && Date.now() > st.end) { expire(); return; }

  const bell = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 8 3 8H3s3-1 3-8M10.3 20a1.9 1.9 0 0 0 3.4 0" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const root = document.createElement('div');
  root.className = 'aw';
  root.hidden = true;
  root.innerHTML = `
    <div class="aw__sky" data-close></div>
    <div class="aw__card" role="dialog" aria-modal="true" aria-labelledby="aw-t" tabindex="-1">
      <button type="button" class="aw__x" data-close aria-label="Sluiten"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button>
      <div class="aw__clock" aria-hidden="true">
        <span class="aw__wave aw__wave--l"></span><span class="aw__wave aw__wave--r"></span>
        <div class="aw__dome"><span class="aw__glow"></span></div>
        <div class="aw__base"><span class="aw__led" data-led>20:00</span></div>
      </div>
      <p class="aw__kicker">${bell} Triiing! Het is tijd.<span class="aw__mini" data-led>20:00</span></p>
      <h2 class="aw__title" id="aw-t"><span>-10 €</span> op je Gloorlicht</h2>
      <p class="aw__sub">Een welkomstcadeau, <b>20 minuten</b> geldig. De tijd loopt af op het display van de wekker.</p>
      <div class="aw__code"><span>Code</span><strong>${CODE}</strong><button type="button" data-copy>Kopiëren</button></div>
      <a class="aw__cta" href="/discount/${CODE}" data-apply>Nu gebruiken</a>
      <button type="button" class="aw__later" data-close>Nee bedankt, ik kijk eerst rond</button>
      <p class="aw__fine">Eén keer per klant, niet te combineren met de duo-aanbieding. De code wordt automatisch toegepast in je winkelwagen en vervalt na 20 minuten.</p>
    </div>`;
  const pill = document.createElement('button');
  pill.type = 'button';
  pill.className = 'aw-pill';
  pill.hidden = true;
  pill.innerHTML = `${bell}<span>-10 € · <b data-led>20:00</b></span>`;
  pill.setAttribute('aria-label', 'Aanbieding van -10 € opnieuw openen');

  const mount = () => { document.body.append(root, pill); };
  if (document.body) mount(); else document.addEventListener('DOMContentLoaded', mount);

  const fmt = (ms) => { const s = Math.max(0, Math.ceil(ms / 1000)); return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`; };
  let timer = 0;
  const tick = () => {
    const left = st.end - Date.now();
    document.querySelectorAll('.aw [data-led], .aw-pill [data-led]').forEach((n) => { n.textContent = fmt(left); });
    pill.classList.toggle('is-hurry', left < 60000);
    if (left <= 0) { clearInterval(timer); expire(); }
  };
  const start = () => {
    if (!st) { st = { end: Date.now() + MS }; if (!force) set(st); }
    clearInterval(timer); tick(); timer = setInterval(tick, 1000);
  };

  let lastFocus = null;
  const open = () => {
    lastFocus = document.activeElement;
    root.hidden = false; pill.hidden = true;
    document.documentElement.style.overflow = 'hidden';
    root.classList.remove('is-leaving');
    requestAnimationFrame(() => root.classList.add('is-on'));
    if (reduce) root.classList.add('is-lit');
    else setTimeout(() => root.classList.add('is-lit'), 1500);
    try { navigator.vibrate?.([80, 60, 80]); } catch (e) {}
    start();
    setTimeout(() => root.querySelector('.aw__card').focus({ preventScroll: true }), 60);
  };
  const close = () => {
    root.classList.add('is-leaving');
    setTimeout(() => {
      root.hidden = true; root.classList.remove('is-on', 'is-leaving');
      document.documentElement.style.overflow = '';
      if (st && st.end > Date.now()) pill.hidden = false;
      lastFocus?.focus?.({ preventScroll: true });
    }, reduce ? 0 : 350);
  };

  root.addEventListener('click', async (e) => {
    if (e.target.closest('[data-close]')) close();
    else if (e.target.closest('[data-copy]')) {
      const b = e.target.closest('[data-copy]');
      try { await navigator.clipboard.writeText(CODE); b.textContent = 'Gekopieerd ✓'; } catch (err) { b.textContent = CODE; }
    } else if (e.target.closest('[data-apply]')) {
      e.preventDefault();
      if (st) { st.applied = true; if (!force) set(st); }
      location.href = `/discount/${CODE}?redirect=${encodeURIComponent(location.pathname)}`;
    }
  });
  root.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      const f = [...root.querySelectorAll('button, a[href]')].filter((n) => n.offsetParent);
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f.at(-1).focus(); }
      else if (!e.shiftKey && document.activeElement === f.at(-1)) { e.preventDefault(); f[0].focus(); }
    }
  });
  pill.addEventListener('click', open);

  // Fin du minuteur : on retire le code du panier (s'il y est) et on n'affiche plus rien
  function expire() {
    const s = get() || {};
    if (!s.expired) {
      s.expired = true; set(s);
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) }).catch(() => {});
    }
    document.querySelectorAll('.aw, .aw-pill').forEach((n) => { n.hidden = true; });
    document.documentElement.style.overflow = '';
  }

  // Visite suivante pendant les 20 minutes : la pastille seule
  if (st && st.end) { const show = () => { pill.hidden = false; start(); }; document.body ? show() : document.addEventListener('DOMContentLoaded', show); return; }

  // Première visite : après la bannière cookies, pour ne jamais empiler deux fenêtres
  const bannerUp = () => { const b = document.getElementById('shopify-pc__banner'); return !!(b && b.offsetHeight && getComputedStyle(b).visibility !== 'hidden'); };
  let sawBanner = false;
  const wait = () => {
    if (bannerUp()) { sawBanner = true; setTimeout(wait, 400); return; }
    setTimeout(open, sawBanner ? 700 : 0);
  };
  setTimeout(wait, force ? 300 : 10000); // 10 s sur le site avant de sonner
})();
